import isEqual from 'lodash.isequal';

export const getFieldsAreEqual = (keys = []) => (prevProps, nextProps) => {
  if (!prevProps) {
    return false;
  }

  if (!keys.length) {
    return isEqual(prevProps, nextProps);
  }

  const { fields: prevFields, ...comparablePrevProps } = prevProps;
  const { fields: nextFields, ...comparableNextProps } = nextProps;

  return (
    isEqual(comparableNextProps, comparablePrevProps) && !keys.some(key => !isEqual(prevFields[key], nextFields[key]))
  );
};
